import * as React from 'react';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import Dialog from 'src/components/common/Dialog';
import Button from 'src/components/controls/forms/redesign/FormButton';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
import CheckRegisterItem from 'src/models/personnel/CheckRegisterItem';

interface IVoidCheckDialogProps {
    dialogName: string;
    hideDialog: () => void;
    check?: CheckRegisterItem;
    onConfirm?: (voidReason: string) => void;
}

// Mirrors the grid's own editable VOID field (PRE-UPDATE trigger, oid 30) - modeled on
// InvoiceMaintenancePageComponent's VoidInvoiceDialog pattern (select a row, click Void, confirm
// with a reason), acting on whichever single row was last clicked in the grid. One-way: Oracle's
// trigger only ever handles N->Y and never restores the TIME_SHEET link it strips, so un-voiding
// was dropped rather than ported - it would just flip the flag back without undoing the real
// effect, which is a gap in the original form, not a feature. VOID_DSCR is a new column added at
// the user's request to capture the reason - Oracle's own VOID field has no such column.
const VoidCheckDialog = (props: IVoidCheckDialogProps) => {
    const { register, getValues, setValue } = useForm();

    useEffect(() => {
        setValue('voidReason', '');
    }, [props.check, setValue]);

    const handleConfirm = () => {
        const values = getValues();
        if (props.onConfirm) {
            props.onConfirm(values.voidReason ?? '');
        }
    };

    return (
        <Dialog title="Void Check" dialogName={props.dialogName} isExitButtonInvisible={true} bodyStyle={{ width: '35%' }}>
            <div style={{ marginBottom: '1rem' }}>
                <div>Check #: <strong>{props.check?.checkNo}</strong></div>
                <div>Paid To: <strong>{props.check?.paidTo}</strong></div>
                <div>Period #: <strong>{props.check?.periodNo}</strong></div>
            </div>
            <RHFInputBox label="Reason" name="voidReason" type="text" register={register} style={{ width: '100%' }} bodyStyle={{ width: '100%' }} />
            <div className="form-row" style={{ marginTop: '2rem', justifyContent: 'center' }}>
                <Button className="blue-hover-button" style={{ width: 'auto', marginRight: '1rem' }} text="Void" onClick={handleConfirm} />
                <Button className="blue-hover-button" style={{ width: 'auto' }} text="Cancel" onClick={() => props.hideDialog()} />
            </div>
        </Dialog>
    );
};

export default VoidCheckDialog;



// WEBPACK FOOTER //
// ./src/components/personnel/dialogs/checkRegister/VoidCheckDialog.tsx